import { Link } from 'react-router-dom';
import { withRbac } from '..';
export var RbacLink = withRbac(Link);
export default RbacLink;